import { createAction, props } from '@ngrx/store';
import { FormState } from './formInscription.reducer';

export const loadForm = createAction('[FormInscription] Load FormInscription');

export const saveForm = createAction('[FormInscription] Save FormInscription');

export const updateForm = createAction(
    '[FormInscription] Update FormInscription',
    props<FormState>()
);

